function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#20ad9b;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M308.084,68.823c-2.1-1.574-3.911-2.934-3.911-6.736a1.086,1.086,0,1,0-2.173,0c0,4.889,2.54,6.793,4.781,8.474,2.1,1.574,3.911,2.934,3.911,6.736a1.086,1.086,0,0,0,2.173,0C312.864,72.407,310.324,70.5,308.084,68.823Z",
  transform: "translate(-280.127 -61)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M424.173,62.086a1.086,1.086,0,0,0-2.173,0c0,4.675,1.251,6.551,2.355,8.208,1.024,1.535,1.99,2.986,1.99,7a1.086,1.086,0,1,0,2.173,0c0-4.675-1.251-6.551-2.355-8.208C425.139,67.554,424.173,66.1,424.173,62.086Z",
  transform: "translate(-391.435 -61)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.11,331H1.086A1.086,1.086,0,0,0,0,332.086V338.6a1.086,1.086,0,0,0,1.086,1.086H13.11Z",
  transform: "translate(0 -311.444)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M211,331h15.282v8.691H211Z",
  transform: "translate(-195.718 -311.444)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M455.259,331H452v8.691h3.259a1.086,1.086,0,0,0,1.086-1.086v-6.519A1.086,1.086,0,0,0,455.259,331Z",
  transform: "translate(-419.262 -311.444)"
}));

const SvgIconHabitos = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37.083,
    height: 28.247,
    viewBox: "0 0 37.083 28.247",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconHabitos, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Icon_Habitos.087dfc2a.svg";
export { ForwardRef as ReactComponent };